/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What formula does this calculator use?`)
};

const es_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué fórmula utiliza esta calculadora?`)
};

const de_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Formel verwendet dieser Rechner?`)
};

const nl_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke formule gebruikt deze rekenmachine?`)
};

const fr_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle formule ce calculateur utilise-t-il ?`)
};

const it_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale formula utilizza questo calcolatore?`)
};

const pt_br2_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual fórmula essa calculadora usa?`)
};

const pt_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual fórmula utiliza esta calculadora?`)
};

const ja_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この計算機はどの公式を使用していますか？`)
};

const zh_hw_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个计算器使用什么公式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq3_q", locale)
	if (locale === "en") return en_hw_faq3_q(inputs)
	if (locale === "es") return es_hw_faq3_q(inputs)
	if (locale === "de") return de_hw_faq3_q(inputs)
	if (locale === "nl") return nl_hw_faq3_q(inputs)
	if (locale === "fr") return fr_hw_faq3_q(inputs)
	if (locale === "it") return it_hw_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq3_q(inputs)
	if (locale === "pt") return pt_hw_faq3_q(inputs)
	if (locale === "ja") return ja_hw_faq3_q(inputs)
	return zh_hw_faq3_q(inputs)
};